import { AfterViewInit, Directive, ElementRef } from "@angular/core";

@Directive({
    selector: '[lineClampCheck]',
})
export class LineClampCheckDirective implements AfterViewInit {
    constructor(private element: ElementRef) {
    }
    ngAfterViewInit(): void {
        const el = this.element.nativeElement;
        if (el.scrollHeight <= el.clientHeight) {
            this.element.nativeElement.classList.add('hide-view-more');
        }
    }
}  